import { workerClient } from './api/workerClient';
import { ApiResponse } from '../types/api.types';
import { SearchResult, Category } from '../types/store.types';

export const storeService = {
    getCategories: async (): Promise<Category[]> => {
        const response = await workerClient.get<ApiResponse<Category[]>>('categories');
        return response.data.data!;
    },

    getFeaturedProducts: async (): Promise<SearchResult> => {
        const response = await workerClient.get<ApiResponse<SearchResult>>('search', {
            params: { sort: 'popularity', size: 8 }
        });
        return response.data.data!;
    },

    getRecommendedProducts: async (): Promise<SearchResult> => {
        const response = await workerClient.get<ApiResponse<SearchResult>>('search', {
            params: { sort: 'latest', size: 8 }
        });
        return response.data.data!;
    },

    searchProducts: async (params: { q?: string; page?: number; size?: number; category?: string; sort?: string }): Promise<SearchResult> => {
        const response = await workerClient.get<ApiResponse<SearchResult>>('search', { params });
        return response.data.data!;
    },
};
